import { oz } from '@weft/utils';
import { SalesforceContactSchema } from './salesforce-contact-schema';

export const SalesforceAccountSchema = oz.object({
  Id: oz.string(),
  Name: oz.string(),
  BillingAddress: oz.object({
    street: oz.string().nullable(),
    city: oz.string().nullable(),
    postalCode: oz.string().nullable(),
    country: oz.string().nullable(),
  }).nullable(),
  Contacts: oz.array(SalesforceContactSchema).optional(),
}).openapi('SalesforceAccount');

export type SalesforceAccount = oz.infer<typeof SalesforceAccountSchema>;